<template>
    <Multiselect
        v-bind="forwardedAttrs"    
        ref="multiselect"
        :options="sortedProductOptions"
        :searchable="true"
        valueProp="id"
        :trackBy="['id', 'title']"
        label="title"
        :placeholder="placeholder"
        :loading="loading"
        @select="onSelect"
    >
        <template #option="slotProps">
            <slot name="option" v-bind="slotProps">
                <span
                    :class="{
                        'text-red-500': isSpecialOrderBlocked(slotProps.option),
                        'text-gray-400': slotProps.option.enabled === false || slotProps.option.available === 0,
                    }"
                >
                    <div v-if="slotProps.option.available === 0">
                        <span class="text-xs text-white bg-red-400 rounded py-1 px-2">
                            Out of Stock
                        </span>
                    </div>

                    <span v-if="!isCustomer">{{ slotProps.option.id }} - </span>{{ slotProps.option.title }}
                    <span class="text-xs italic text-red" v-if="slotProps.option.special_order">
                        (Special Order Item)
                    </span>
                </span>
            </slot>
        </template>
    </Multiselect>
</template>

<script>
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'

export default {
    name: 'ProductMultiselect',
    components: { Multiselect },
    inheritAttrs: false,

    props: {
        productOptions: true,
        placeholder: 'Select Product',
        loading: true,
        isCustomer: false,
        canAddSpecialOrderItems: true,
    },

    computed: {

        sortedProductOptions() {
            return [...this.productOptions].sort((a, b) => {
                // active status (enabled first)
                const aEnabled = !!a.enabled
                const bEnabled = !!b.enabled
                if (aEnabled !== bEnabled) {
                    return aEnabled ? -1 : 1
                }

                // availability (in stock first)
                const aInStock = (a.available || 0) > 0
                const bInStock = (b.available || 0) > 0
                if (aInStock !== bInStock) {
                    return aInStock ? -1 : 1
                }

                // alphabetical
                const aTitle = (a.title || '').toString().toLowerCase()
                const bTitle = (b.title || '').toString().toLowerCase()
                return aTitle.localeCompare(bTitle)
            })
        },

        forwardedAttrs() {
            const attrs = { ...this.$attrs };
            // Remove event listeners to avoid duplicate emissions
            Object.keys(attrs).forEach(key => {
                if (key.startsWith('on')) delete attrs[key];
            });
            return attrs;
        },
    },
    data() {
        return { lastSelectTs: 0 };
    },
    methods: {
        isSpecialOrderBlocked(option) {
            if (!option || option.special_order !== true) {
                return false;
            }

            if (option.special_order_allowed === false) {
                return true;
            }

            if (option.special_order_allowed === true) {
                return false;
            }

            return !this.canAddSpecialOrderItems;
        },
        onSelect(option) {
            this.$emit('select', option)
        },
        clear() {
            if (this.$refs.multiselect && typeof this.$refs.multiselect.clear === 'function') {
                this.$refs.multiselect.clear()
            }
        },
    },
}
</script>
